import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
	createProduct,
	updateProduct,
	deleteProduct,
	createBundle,
	updateBundle,
	deleteBundle,
} from '../../api/crmApi';

import { productsKeys, bundlesKeys, productsMutationKeys, bundlesMutationKeys } from './keys';

// Products

export function useCreateProduct() {
	const qc = useQueryClient();
	return useMutation({
		mutationKey: productsMutationKeys.create,
		mutationFn: createProduct,
		onSuccess: () => qc.invalidateQueries({ queryKey: productsKeys.all }),
	});
}

export function useUpdateProduct() {
	const qc = useQueryClient();
	return useMutation({
		mutationKey: productsMutationKeys.update,
		mutationFn: ({ id, payload }) => updateProduct(id, payload),
		onSuccess: () => qc.invalidateQueries({ queryKey: productsKeys.all }),
	});
}

export function useDeleteProduct() {
	const qc = useQueryClient();
	return useMutation({
		mutationKey: productsMutationKeys.delete,
		mutationFn: deleteProduct,
		// Also invalidate bundles — they may contain the deleted product
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: productsKeys.all });
			qc.invalidateQueries({ queryKey: bundlesKeys.all });
		},
	});
}

// Bundles

export function useCreateBundle() {
	const qc = useQueryClient();
	return useMutation({
		mutationKey: bundlesMutationKeys.create,
		mutationFn: createBundle,
		onSuccess: () => qc.invalidateQueries({ queryKey: bundlesKeys.all }),
	});
}

export function useUpdateBundle() {
	const qc = useQueryClient();
	return useMutation({
		mutationKey: bundlesMutationKeys.update,
		mutationFn: ({ id, payload }) => updateBundle(id, payload),
		onSuccess: () => qc.invalidateQueries({ queryKey: bundlesKeys.all }),
	});
}

export function useDeleteBundle() {
	const qc = useQueryClient();
	return useMutation({
		mutationKey: bundlesMutationKeys.delete,
		mutationFn: deleteBundle,
		onSuccess: () => qc.invalidateQueries({ queryKey: bundlesKeys.all }),
	});
}
